import React from 'react';

import * as helpers from './helpers';

const EngravingIcon = ({
  color,
  width = 29,
  height = 29,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    fill="none"
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}>
    <path
      d="M8.04275 14.6422L18.7565 3.92845C20.3403 2.34461 22.9082 2.34461 24.4921 3.92845C26.0759 5.51228 26.0759 8.08019 24.4921 9.66402L13.7783 20.3778C12.8095 21.3466 11.5014 21.9001 10.1314 21.9208C9.26954 21.9339 8.41813 22.1114 7.62288 22.4438L4.79466 23.6259L5.97678 20.7977C6.30917 20.0024 6.48666 19.151 6.4997 18.2892C6.52043 16.9191 7.07389 15.6111 8.04275 14.6422Z"
      stroke={color}
      strokeWidth={1.5}
    />

  </svg>
);

export default EngravingIcon;
